export function createSerializationScope(nodeIds) {
    return { nodeIds };
}
//# sourceMappingURL=serializationScope.js.map